import TeamAccessModal from './team-access-modal';

import './team-access-modal.scss';

export default TeamAccessModal;
